import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../../api/client'
import type { ProfilePatch } from '../../lib/types'

/** Leave/vacation balances (источник 1С) — GET /users/me/balances. */
export function useBalances() {
  return useQuery({ queryKey: ['balances'], queryFn: api.balances })
}

/** Edit own profile (phone / skills) — PATCH /users/me. */
export function useUpdateMe(onDone?: () => void) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: ProfilePatch) => api.updateMe(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['me'] })
      onDone?.()
    },
  })
}

/** Upload a new avatar (multipart field "file") — POST /users/me/avatar. */
export function useUploadAvatar() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (form: FormData) => api.uploadAvatar(form),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['me'] }),
  })
}

/** My preferences (notifications / privacy / appearance) — GET /users/me/preferences. */
export function usePreferences() {
  return useQuery({ queryKey: ['preferences'], queryFn: api.preferences })
}
